module.exports = __webpack_public_path__ + "img/ccv.397e5cf.png";